import { useMutation, useQuery } from '@tanstack/react-query';

import type { ValidateDiscountCodeRequestDto } from '@/api/common/discount-policy';
import {
  getEarlybirdDiscount,
  getEnrolledDiscountCodes,
  validateDiscountCode,
} from '@/api/common/discount-policy';
import type { PlusCourse, PlusLiteCourse } from '@/types';

export const earlybirdDiscountQueryKeys = {
  all: ['earlybirdDiscount'],
  byCourseName: (courseName: string | undefined) => [
    ...earlybirdDiscountQueryKeys.all,
    courseName,
  ],
};

export const enrolledDiscountCodesQueryKeys = {
  all: ['enrolledDiscountCodes'],
  byOnlineUserId: (onlineUserId: string | undefined) => [
    ...enrolledDiscountCodesQueryKeys.all,
    onlineUserId,
  ],
};

export function useGetEarlybirdDiscount(
  courseName: PlusCourse | PlusLiteCourse | undefined,
) {
  return useQuery({
    queryKey: earlybirdDiscountQueryKeys.byCourseName(courseName),
    queryFn: () => getEarlybirdDiscount(courseName),
    enabled: !!courseName,
  });
}

export function useValidateDiscountCode() {
  return useMutation({
    mutationFn: (data: ValidateDiscountCodeRequestDto) =>
      validateDiscountCode(data),
  });
}

export function useGetEnrolledDiscountCodes(onlineUserId?: string) {
  return useQuery({
    queryKey: enrolledDiscountCodesQueryKeys.byOnlineUserId(onlineUserId),
    queryFn: () => getEnrolledDiscountCodes(onlineUserId as string),
    enabled: !!onlineUserId,
  });
}
